import * as React from "react";
import { LocalizedText } from "bernie-l10n";
import { classNames } from "uitk-react-utils";
import { locKeys } from "src/components/flexComponents/WizardHotelPWA/components/l10n";

export const LegalText = ({ showMoreStrategy, className }: { showMoreStrategy: string; className?: string }) => {
  const legalRequirementClassName =
    showMoreStrategy !== "top_link"
      ? "uitk-type-200 all-b-padding-six uitk-type-center"
      : "uitk-type-200 all-b-padding-six all-t-padding-three uitk-type-center";

  return (
    <div className={classNames("legalText", legalRequirementClassName, className)}>
      <LocalizedText message={locKeys.hotelLegalDisclaimer} />
    </div>
  );
};
